<template>
  <section>
    <input type="checkbox" v-model="isChecked" class="z-checkbox-small" />
  </section>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'user-checkbox',
  props: {
    user: Object,
  },
  computed: {
    isChecked: {
      get() {
        return this.user.isChecked
      },
      set(value) {
        this.setChecked({
          user: this.user,
          isChecked: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('users', ['setChecked']),
  },
}
</script>
